// extracted by mini-css-extract-plugin
export var image = "ImageLockup-module--image--A-Xga";
export var imageWrapper = "ImageLockup-module--imageWrapper--IpuKf";
export var root = "ImageLockup-module--root--XCSRm";